import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Swal from 'sweetalert2';
import { getAllContacts, deleteContact } from '../api/auth/ContactusService';

function Contactusdetails() {
    const [data, setData] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await getAllContacts();
            setData(response);
        } catch (error) {
            console.error('Error fetching data:', error);
            Swal.fire(
                'Error!',
                'There was a problem fetching contacts.',
                'error'
            );
        }
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this entry!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await deleteContact(id);
                    setData(data.filter(item => item.id !== id));
                    Swal.fire(
                        'Deleted!',
                        'The contact has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting contact:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the contact.',
                        'error'
                    );
                }
            }
        });
    };

    return (
        <div>
            <Sidebar />
            <div className="col-md-9 px-0" style={{ marginLeft: '210px' }}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h5 className="page-title">Contact Us Detail</h5>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-md-10 mt-3" style={{ marginLeft: '210px' }}>
                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                            <th>Subject</th>
                            <th>Address</th>
                            <th>Message</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.name || 'N/A'}</td>
                                <td>{item.email || 'N/A'}</td>
                                <td>{item.phone || 'N/A'}</td>
                                <td>{item.subject || 'N/A'}</td>
                                <td>{item.address || 'N/A'}</td>
                                <td>{item.message || 'N/A'}</td>
                                <td>{item.date || 'N/A'}</td>
                                <td>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => handleDelete(item.id)}
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default Contactusdetails;